/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ProposalDecision,
  ProposalOutcome
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Save a proposed CRM change, once, as the advisor who is confirming it.
 *
 * 404 for a proposal that is not this user's, this chat's or this org's (the
 * same answer for all three, so an id reveals nothing), 410 when it expired,
 * 409 when it was cancelled, refused, or is mid-save. Confirming again after a
 * success answers the first result with `replayed: true` and writes nothing.
 * @summary Confirm Proposal
 */
export const soteriaConfirmProposal = (
    proposalId: string,
    proposalDecision: ProposalDecision,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<ProposalOutcome>(
      {url: `/soteria/proposals/${proposalId}/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: proposalDecision, signal
    },
      options);
    }




export const getSoteriaConfirmProposalMutationKey = () => ['soteriaConfirmProposal'] as const;

export const getSoteriaConfirmProposalMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soteriaConfirmProposal>>, TError,SoteriaConfirmProposalMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof soteriaConfirmProposal>>, TError,SoteriaConfirmProposalMutationVariables, TContext> => {

const mutationKey = getSoteriaConfirmProposalMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof soteriaConfirmProposal>>, SoteriaConfirmProposalMutationVariables> = (props) => {
          const {proposalId,data} = props ?? {};

          return  soteriaConfirmProposal(proposalId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SoteriaConfirmProposalMutationResult = NonNullable<Awaited<ReturnType<typeof soteriaConfirmProposal>>>
    export type SoteriaConfirmProposalMutationBody = ProposalDecision
    export type SoteriaConfirmProposalMutationError = HTTPValidationError
    export type SoteriaConfirmProposalMutationVariables = {proposalId: string;data: ProposalDecision}

    /**
 * @summary Confirm Proposal
 */
export const useSoteriaConfirmProposal = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof soteriaConfirmProposal>>, TError,SoteriaConfirmProposalMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof soteriaConfirmProposal>>,
        TError,
        SoteriaConfirmProposalMutationVariables,
        TContext
      > => {
      return useMutation(getSoteriaConfirmProposalMutationOptions(options));
    }
